import { Drawer } from 'antd'
import React, { FunctionComponent, useCallback } from 'react'

import { DRAWER_TYPE, resetLvDrawer } from '../../../redux/drawerSlice'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { propertyDrawerWrapperStyle } from '../../utils/layoutConst'
import { useFetchLvDetailData } from '../../utils/useFetchLvDetailData'
import { LvDetailDrawerBody } from '../LvDetailDrawerBody/LvDetailDrawerBody'
import { LvDetailDrawerHeader } from '../LvDetailDrawerHeader/LvDetailDrawerHeader'
import { PropertyDetailFetchError } from '../PropertyDetailFetchError/PropertyDetailFetchError'

export const LvDetailDrawer: FunctionComponent = () => {
  const drawer = useAppSelector(state => state.drawer?.[DRAWER_TYPE.LV])
  const dispatch = useAppDispatch()

  const { fetching, error, data } = useFetchLvDetailData(
    drawer?.lvCode,
    drawer?.lvNumber
  )

  const handleClose = useCallback(() => dispatch(resetLvDrawer()), [dispatch])

  return (
    <Drawer
      styles={propertyDrawerWrapperStyle.styles}
      title={<LvDetailDrawerHeader />}
      open={!!drawer?.lvNumber && !!drawer?.lvCode}
      onClose={handleClose}
      loading={fetching}
    >
      {error ? (
        <PropertyDetailFetchError
          description="Je nám líto, ale nepodařilo se dohledat detailní informace o listu vlastnictví."
          message={`LV nenalezeno`}
        />
      ) : (
        <LvDetailDrawerBody
          geometryData={data?.geometryData}
          lvData={data?.lvData}
        />
      )}
    </Drawer>
  )
}
